import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api/api.service';
import { Section } from 'src/app/models/section';

@Injectable({
  providedIn: 'root',
})
export class SectionsService {
  getSections(templateId: number): Observable<Section[]> {
    return this.apiService.get<Section[]>(`/dashboard/section_all/${templateId}`);
  }

  getSection(sectionId: number): Observable<Section> {
    return this.apiService.get<Section>(`/dashboard/section/${sectionId}`);
  }

  saveSectionsSortingOrder(templateId: number, sortingOrder: number[]): Observable<number[]> {
    return this.apiService.put<number[]>(`/dashboard/feedback/${templateId}/section_sort`, sortingOrder);
  }

  createSection(section: Section): Observable<Section> {
    return this.apiService.post<Section>(`/dashboard/section`, section);
  }

  updateSection(section: Section): Observable<Section> {
    return this.apiService.put<Section>(`/dashboard/section/${section.id}`, section);
  }

  deleteSection(section: Section): Observable<Section> {
    return this.apiService.delete<Section>(`/dashboard/section/${section.id}`);
  }

  constructor(private apiService: ApiService) {}
}
